(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lun-video-carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.currentScript?.closest('.lun-video-carousel')
    || document.querySelector('[data-section-id="{{ section.id }}"]');
  if (!section) return;

  const track = section.querySelector('.lun-vc-track');
  const prev = section.querySelector('.lun-vc-nav--prev');
  const next = section.querySelector('.lun-vc-nav--next');
  if (!track) return;

  const scrollAmount = () => {
    const card = track.querySelector('.lun-vc-card');
    if (!card) return 300;
    const gap = parseFloat(getComputedStyle(track).gap) || 16;
    return card.offsetWidth + gap;
  };

  prev?.addEventListener('click', () => {
    track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });

  next?.addEventListener('click', () => {
    track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });

  section.querySelectorAll('video').forEach(v => {
    v.muted = true;
    v.autoplay = true;
    v.loop = true;
    v.controls = false;
    v.setAttribute('playsinline', '');
    v.play().catch(() => {});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
